import Button from '@loggi/ui/components/button';
import Text, { TEXT_SIZE_LARGE } from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import icons from '@loggi/ui/components/utils/icons';
import View from '@loggi/ui/components/view';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './classification-header.component.styles.scss';

const ClassificationHeader = props => {
  const BackButton = onClickBackButton => {
    return (
      <Button
        data-testid="back-btn"
        size="large"
        className="backButton"
        icon={icons.type.BACK}
        // eslint-disable-next-line react/style-prop-object
        style="outline"
        shape="circle"
        onClick={onClickBackButton}
      />
    );
  };

  const { headerText, className, onClickBack } = props;

  return (
    <View
      flex
      flexDirection="column"
      justifyContent="start"
      alignItems="start"
      className={`${styles.header} ${className}`}
      gutter={{ top: 'double', right: 'double', left: 'double' }}
    >
      <View className="actionButtons">{BackButton(onClickBack)}</View>
      <Text size={TEXT_SIZE_LARGE} color={colors.type.WHITE}>
        {headerText}
      </Text>
    </View>
  );
};

ClassificationHeader.propTypes = {
  headerText: PropTypes.string,
  className: PropTypes.string,
  onClickBack: PropTypes.func.isRequired
};

ClassificationHeader.defaultProps = {
  headerText: null,
  className: null
};

export default ClassificationHeader;
